import React, { useState } from "react";
import { Link } from "react-router-dom";
import { http, formatApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setError(""); setSubmitting(true);
        try {
            await http.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) { setError(formatApiError(err)); }
        finally { setSubmitting(false); }
    }

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="label-eyebrow mb-4">/ Account recovery</div>
                <h1 className="font-serif text-4xl mb-8">Forgot your <span className="gold-text italic">password?</span></h1>

                {sent ? (
                    <div data-testid="forgot-success" className="bg-slate-900/60 border border-gold/30 rounded-sm p-6">
                        <p className="text-slate-200">
                            If an account exists for <span className="gold-text">{email}</span>, a reset link has been sent.
                        </p>
                        <p className="text-sm text-slate-400 mt-4">Check your inbox (and spam folder). The link expires in 1 hour.</p>
                        <Link to="/login" className="btn-gold inline-block mt-6">Back to sign in</Link>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
                        <p className="text-slate-400 text-sm">
                            Enter the email associated with your account and we'll send you a secure reset link.
                        </p>
                        <div>
                            <label className="text-xs uppercase tracking-widest text-slate-400">Email</label>
                            <input
                                data-testid="forgot-email"
                                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                            />
                        </div>
                        {error && <div data-testid="forgot-error" className="text-sm text-red-400">{error}</div>}
                        <button data-testid="forgot-submit" disabled={submitting} className="btn-gold w-full disabled:opacity-50">
                            {submitting ? "Sending…" : "Send reset link"}
                        </button>
                        <div className="text-sm text-slate-400 text-center">
                            Remembered? <Link to="/login" className="gold-text hover:underline">Back to sign in</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
